__webpack_require__.p = "/wordpress/wp-content/plugins/woo-order-cart/ips-react/build/";